export const ICONS = {
  InfoIconSvg: (
    <svg
      width='28'
      height='24'
      viewBox='2 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 0C6.26856 0 0 6.27081 0 14C0 21.7337 6.26856 28 14 28C21.7314 28 28 21.7337 28 14C28 6.27081 21.7314 0 14 0ZM14 6.20968C15.3095 6.20968 16.371 7.27119 16.371 8.58064C16.371 9.8901 15.3095 10.9516 14 10.9516C12.6905 10.9516 11.629 9.8901 11.629 8.58064C11.629 7.27119 12.6905 6.20968 14 6.20968ZM17.1613 20.5484C17.1613 20.9225 16.858 21.2258 16.4839 21.2258H11.5161C11.142 21.2258 10.8387 20.9225 10.8387 20.5484V19.1935C10.8387 18.8194 11.142 18.5161 11.5161 18.5161H12.1935V14.9032H11.5161C11.142 14.9032 10.8387 14.5999 10.8387 14.2258V12.871C10.8387 12.4969 11.142 12.1935 11.5161 12.1935H15.129C15.5031 12.1935 15.8065 12.4969 15.8065 12.871V18.5161H16.4839C16.858 18.5161 17.1613 18.8194 17.1613 19.1935V20.5484Z'
        fill='#7CADA2'
      />
    </svg>
  ),
  MembershipCheckSvg: (
    <svg
      width='28'
      height='21'
      viewBox='0 0 28 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.51004 20.5876L0.410034 11.4352C-0.136678 10.8854 -0.136678 9.99385 0.410034 9.44394L2.38989 7.45265C2.9366 6.90274 3.82308 6.90274 4.36979 7.45265L10.5 13.618L23.6302 0.412391C24.1769 -0.137464 25.0634 -0.137464 25.6101 0.412391L27.59 2.40368C28.1367 2.95354 28.1367 3.84507 27.59 4.39498L11.49 20.5876C10.9432 21.1375 10.0568 21.1375 9.51004 20.5876Z'
        fill='#005E47'
      />
    </svg>
  ),
  XIconSvg: (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='32'
      height='32'
      viewBox='-6 -6 44 44'
      xmlSpace='preserve'
    >
      <style type='text/css'>{`.st0{fill:#FFFFFF;}`}</style>
      <path
        className='st0'
        d='M19,13.5L30.6,0h-2.8L17.8,11.8L9.7,0H0.3l12.2,17.8L0.3,32h2.8l10.7-12.4L22.3,32h9.3L19,13.5L19,13.5z M15.2,17.9L14,16.2L4.1,2.1h4.2l8,11.4l1.2,1.8L27.9,30h-4.2L15.2,17.9L15.2,17.9z'
      />
    </svg>
  ),
  XIconGreenSvg: (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='32'
      height='32'
      viewBox='-12 -12 54 54'
      xmlSpace='preserve'
    >
      <style type='text/css'>{`.st1{fill:#004131;}`}</style>
      <path
        className='st1'
        d='M19,13.5L30.6,0h-2.8L17.8,11.8L9.7,0H0.3l12.2,17.8L0.3,32h2.8l10.7-12.4L22.3,32h9.3L19,13.5L19,13.5z M15.2,17.9L14,16.2L4.1,2.1h4.2l8,11.4l1.2,1.8L27.9,30h-4.2L15.2,17.9L15.2,17.9z'
      />
    </svg>
  ),
}
